/* tslint:disable:jsx-no-lambda */
import DeepLinkMailView from './DeepLinkMailView';
import DeepLinkYammerView from './DeepLinkYammerView';
import { observer } from 'mobx-react-lite';
import App from 'owa-application/lib/components/App';
import Droppable from 'owa-dnd/lib/components/Droppable';
import createDropViewState from 'owa-dnd/lib/utils/createDropViewState';
import { ImmersiveReaderContainer } from 'owa-immersive-reader';
import { isFeatureEnabled } from 'owa-feature-flags';
import { lazyResetFocus } from 'owa-mail-focus-manager';
import setTypeOfItemBeingDragged from 'owa-mail-store/lib/actions/setTypeOfItemBeingDragged';
import store from 'owa-mail-store/lib/store/Store';
import * as React from 'react';
import { lazySetupUndoHotKeys } from 'owa-mail-hotkeys';
import { useLazyKeydownHandler } from 'owa-hotkeys';
import { SearchAnswer } from 'owa-search-answer-deeplink';
import { SaveToCloudTab } from 'owa-attachment-savetocloud-deeplink';
import { SxSDeeplink } from 'owa-attachment-sxs-deeplink';
import { useDragHelpers } from 'owa-mail-module-view/lib/components/hooks/useDragHelpers';

const styles = require('owa-mail-module-view/lib/components/MailModule.scss');

export interface DeepLinkModuleProps {
    subRoute: string;
}

export default observer(function DeepLinkModule(props: DeepLinkModuleProps) {
    React.useEffect(() => {
        // Set initial focus after component is mounted
        lazyResetFocus.importAndExecute();
        // Override min-width on the global style after mount.
        document.body.style.minWidth = '0';
    }, []);
    const dragHelpers = useDragHelpers(setDataItemType);
    useLazyKeydownHandler(undefined, lazySetupUndoHotKeys.importAndExecute, undefined);

    switch (props.subRoute) {
        case 'attachment':
            return (
                <App renderHeader={() => null}>
                    <SxSDeeplink />
                </App>
            );
        case 'saveAndEdit':
            return (
                <App renderHeader={() => null}>
                    <SaveToCloudTab />
                </App>
            );
        case 'yammer':
            return (
                <App renderHeader={() => null}>
                    <DeepLinkYammerView />
                </App>
            );
        case 'searchAnswer':
            return (
                <App renderHeader={() => null}>
                    <SearchAnswer />
                </App>
            );
        default:
            const emptyDropViewState = createDropViewState();

            return (
                <App renderHeader={() => null}>
                    <Droppable
                        classNames={styles.mailMain}
                        {...dragHelpers}
                        dropViewState={emptyDropViewState}
                        shouldIgnoreTransientOnDragLeave={true}>
                        <div className={styles.allPaneContainer}>
                            <DeepLinkMailView />
                        </div>
                    </Droppable>
                    {isFeatureEnabled('rp-immersiveReader') && <ImmersiveReaderContainer />}
                </App>
            );
    }
});

function setDataItemType(newValue: string) {
    if (store.typeOfItemBeingDragged != newValue) {
        setTypeOfItemBeingDragged(newValue);
    }
}
